import { render } from "./Butirancukai.vue?vue&type=template&id=55792017"
import script from "./Butirancukai.vue?vue&type=script&lang=js"
export * from "./Butirancukai.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__